import { Injectable, Pipe, PipeTransform } from '@angular/core';

import { MoneyService } from '@frontend/sports/common/core/feature/money';
import { Decimal } from 'decimal.js';

@Injectable({ providedIn: 'root' })
@Pipe({
    name: 'bsCurrency',
})
export class CurrencyPipe implements PipeTransform {
    constructor(private moneyService: MoneyService) {}

    transform(
        input: string | number | Decimal | null | undefined,
        symbol?: boolean,
        fractionSize?: number,
        hideEmptyFraction?: boolean,
        locale?: string,
        currencyCode?: string,
        formatCurrency: boolean = true,
    ): string {
        return this.moneyService.transform(input, symbol, fractionSize, hideEmptyFraction, locale, currencyCode, formatCurrency);
    }
}
